// src/components/Home/WhyChooseUs.jsx
import React from "react";
import {
  FaShieldAlt,
  FaClock,
  FaEye,
  FaPlane,
  FaGlobe,
  FaDollarSign,
} from "react-icons/fa";
import "./WhyChooseUs.css";

const WhyChooseUs = () => {
  const features = [
    {
      icon: <FaShieldAlt />,
      title: "Licensed & Compliant",
      description:
        "KRA-ready entries, accurate tariff classification (HS), IDF and permit guidance (KEBS/PPB) to avoid penalties and reworks.",
      color: "#1a73e8",
    },
    {
      icon: <FaClock />,
      title: "Faster Clearance, Lower Dwell",
      description:
        "Streamlined workflows and proactive document checks keep your cargo moving—typical compliant shipments clear in 1–3 working days*.",
      color: "#fbbc04",
    },
    {
      icon: <FaEye />,
      title: "End-to-End Visibility",
      description:
        "Milestone alerts, tracking, and clear status updates across sea, air and road—PO to POD, including warehousing and last-mile.",
      color: "#34a853",
    },
    {
      icon: <FaPlane />,
      title: "Air Shipments & Export Shipping",
      description:
        "JKIA air cargo expertise, airline bookings & AWB, export declarations, and documentation (invoice, packing list, certificate of origin).",
      color: "#ea4335",
    },
    {
      icon: <FaGlobe />,
      title: "Global Partner Network",
      description:
        "Seamless EXW/FOB coordination through trusted partners across Africa, Europe & Asia for reliable lead times and cost control.",
      color: "#1a73e8",
    },
    {
      icon: <FaDollarSign />,
      title: "Transparent, Sales-Ready Pricing",
      description:
        "Clear quotes with inclusions/exclusions, no surprises—giving your team confidence to confirm shipments faster.",
      color: "#fbbc04",
    },
  ];

  return (
    <section className="why-choose-section section section-white">
      <div className="container">
        {/* Section Header */}
        <div className="section-header text-center">
          <h2>Why Choose Falmouth Global Solutions</h2>
          <p className="section-subtitle">
            Experience the difference with our comprehensive logistics solutions
            designed for efficiency and reliability
          </p>
        </div>

        {/* Features Grid */}
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card card">
              <div
                className="feature-icon-wrapper"
                style={{
                  background: `linear-gradient(135deg, ${feature.color}20, ${feature.color}40)`,
                  border: `2px solid ${feature.color}30`,
                }}
              >
                <div className="feature-icon" style={{ color: feature.color }}>
                  {feature.icon}
                </div>
              </div>

              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>

              {/* Feature Highlight */}
              <div
                className="feature-highlight"
                style={{ background: feature.color }}
              ></div>
            </div>
          ))}
        </div>

        {/* Disclaimer Note */}
        <div className="disclaimer-note">
          <p>*After complete and compliant documentation is received.</p>
        </div>

        {/* CTA Section */}
        <div className="why-choose-cta">
          <div className="cta-card card">
            <div className="cta-content">
              <h3>Ready to Experience the Difference?</h3>
              <p>
                Join hundreds of satisfied clients who trust us with their
                logistics needs.
              </p>
              <div className="cta-buttons">
                <button className="btn btn-primary">Get Started Today</button>
                <button className="btn btn-secondary">Contact Our Team</button>
              </div>
            </div>
            <div className="cta-stats">
              <div className="stat">
                <div className="stat-number">100+</div>
                <div className="stat-label">Happy Clients</div>
              </div>
              <div className="stat">
                <div className="stat-number">99%</div>
                <div className="stat-label">On-Time Delivery</div>
              </div>
              <div className="stat">
                <div className="stat-number">24/7</div>
                <div className="stat-label">Customer Support</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
